import * as React from "react";
import { MoneyTextBoxEditor } from "../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { RadiosEditor } from "../../../../../../react-core/Html/RadiosEditor";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../NewBusinessWizard/Components/SharedComponents";

interface IAssumedWrapCashHoldings extends IProcessComponentProps {}
interface AssumedWrapCashHoldingsState {
    selected: boolean;
}
export class AssumedWrapCashHoldings extends ProcessComponent<IAssumedWrapCashHoldings, AssumedWrapCashHoldingsState> {
    constructor(props: any) {
        super(props);
        this.state = { selected: false };
    }
    componentDidMount() {
        super.componentDidMount();
        this.setState({ selected: this.props.data?.Amount != null && this.props.data?.Amount > 0 });
    }
    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <>
                {SectionHeader("Assumed other holdings")}
                {this.renderWrapCash(data, onChange)}
            </>
        );
    }

    private renderWrapCash(data, onChange) {
        const { selected } = this.state;
        return (
            <>
                <RadiosEditor
                    cssWrapper="radio-group rg-150 mb-16"
                    label={"Assumed other holdings"}
                    labelGridClasses="sr-only"
                    selected={selected}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => {
                        onChange({ Amount: 0, Currency: CurrencyCode.GBP });
                        this.setState({ selected: v });
                    }}
                    required={"Please select"}
                />
                {selected && (
                    <MoneyTextBoxEditor
                        label={"Cash value"}
                        labelGridClasses="sr-only"
                        cssWrapper="control-size-180"
                        currency={CurrencyCode.GBP}
                        onChange={(v) => onChange({ Amount: v, Currency: CurrencyCode.GBP })}
                        value={data?.Amount}
                        required={"Please enter cash value"}
                        validationRules={[
                            {
                                errorMessage: "value must be > 0",
                                validator: (v) => v > 0,
                            },
                        ]}
                    />
                )}
            </>
        );
    }
}
